// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { FolderInput } from "./FolderInput";
import {
  instanceOfFolderInput,
  FolderInputFromJSON,
  FolderInputFromJSONTyped,
  FolderInputToJSON,
} from "./FolderInput";
import type { LayerInput } from "./LayerInput";
import {
  instanceOfLayerInput,
  LayerInputFromJSON,
  LayerInputFromJSONTyped,
  LayerInputToJSON,
} from "./LayerInput";

/**
 * @type LayersInner
 *
 * @export
 */
export type LayersInner = ({ type: "folder" } & FolderInput) | ({ type: "layer" } & LayerInput);

export function LayersInnerFromJSON(json: any): LayersInner {
  return LayersInnerFromJSONTyped(json, false);
}

export function LayersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LayersInner {
  if (json == null) {
    return json;
  }
  switch (json["type"]) {
    case "folder":
      return Object.assign({}, FolderInputFromJSONTyped(json, true), { type: "folder" } as const);
    case "layer":
      return Object.assign({}, LayerInputFromJSONTyped(json, true), { type: "layer" } as const);
    default:
      return json;
  }
}

export function LayersInnerToJSON(json: any): any {
  return LayersInnerToJSONTyped(json, false);
}

export function LayersInnerToJSONTyped(
  value?: LayersInner | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }
  switch (value["type"]) {
    case "folder":
      return Object.assign({}, FolderInputToJSON(value), { type: "folder" } as const);
    case "layer":
      return Object.assign({}, LayerInputToJSON(value), { type: "layer" } as const);
    default:
      return value;
  }
}
